export default __webpack_public_path__ + "static/media/PRASHANT.7f88ec54.JPG";